(function(){

    /**
     * Decide how many columns to display based on current window width
     * and the user-specified columns. Forces 1 column if < 600px,
     * otherwise uses the user-specified columns.
     */
    function getResponsiveColumns(baseCols) {
        if (window.innerWidth < 600) {
            return 1;  // Force 1 column on small screens
        }

        if (window.innerWidth < 900) {
            return 2;  // Force 1 column on small screens
        }

        return baseCols; // Otherwise use block’s specified columns
    }

    window.initializeCarousels = initializeCarousels;

    /**
     * Dynamically set each slide's width so exactly `columns` slides plus gap fill the container,
     * clamping the slide width to a maximum of 350px, then center the carousel on the page.
     */
    function setItemWidths(container, track, columns, gapPx){
        const slides = Array.from(track.children);
        if(!slides.length) return;

        // measure container width
        const containerWidth = container.offsetWidth;
        // total gap across (columns - 1) internal spaces
        const totalGap = (columns - 1) * gapPx;

        // Compute ideal itemWidth, then clamp to max=350
        let itemWidth = ((containerWidth - totalGap) / columns) - (gapPx / columns);

        if(itemWidth > 350) {
            itemWidth = 350;
        }

        slides.forEach((slide, idx) => {
            slide.style.width = itemWidth + 'px';
            slide.style.marginRight = (idx < slides.length - 1) ? gapPx + 'px' : '0';
        });

        // Constrain overall carousel width, then center on page
        let totalVisibleWidth = itemWidth * columns + totalGap;

        //if( columns === 1){
            totalVisibleWidth = totalVisibleWidth + gapPx;
        //}

        container.style.maxWidth = totalVisibleWidth + 'px';
        container.style.margin = '0 auto';
        const parentWrap = container.closest('.passivewp-carousel-wrap');
        parentWrap.style.maxWidth = totalVisibleWidth + 100 + 'px';
        parentWrap.style.margin = '0 auto';
    }

    /**
     * measurePageWidth => sums the widths of `columns` slides plus the total gap for those columns.
     */
    function measurePageWidth(track, columns, gapPx){
        const slides = Array.from(track.children);
        if(!slides.length) return 0;

        let total = 0;
        for(let i = 0; i < columns && i < slides.length; i++){
            total += slides[i].offsetWidth;
        }
        // add internal gap for columns-1
        total += (columns - 1) * gapPx;

        // If columns <= 2, add the small tweak (from your original logic)
        if(columns <= 2){
            return total + (gapPx - 1);
        } else {
            return total + (gapPx - 1);
        }
    }

    function initCarousel(container){
        const track = container.querySelector('.passivewp-carousel-track');
        if(!track) return;

        const isEditor   = container.dataset.isEditor === 'true';
        const showArrows = container.dataset.showArrows === 'true';
        const showDots   = container.dataset.showDots   === 'true';
        const infinite   = container.dataset.infinite   === 'true';
        // Read the block's preferred columns from the dataset
        const baseCols   = parseInt(container.dataset.columns,10) || 3;
        const gapPx      = parseInt(container.dataset.gap,10)     || 0;
        const originalCount = parseInt(container.dataset.originalCount || 0,10);

        // We'll store the current effective columns in a variable that can change on resize
        let columns = baseCols;

        // Start currentPage at 1, so pages/dots become more intuitive (1-based)
        let currentPage = 1;
        let transitioning = false;
        let isDown = false;
        let startX = 0;
        let pageWidth = 0;
        let currentTransitionEndCallback = null;

        /**
         * Return how many pages. If infinite + front-end, we might have triple items,
         * but originalCount is the real # of items. So pages = originalCount / columns.
         */
        function pagesCount(){
            if(!originalCount) {
                return Math.ceil(track.children.length / columns);
            }
            return Math.ceil(originalCount / columns);
        }

        function debugLog(...args){
            //console.log('[Carousel]', ...args);
        }

        /**
         * Update the dots based on currentPage (1-based).
         */
        function updateDots(){
            if(!showDots) return;
            const dotsEl = container.querySelector('.passivewp-carousel-pagination');
            if(!dotsEl) return;
            dotsEl.innerHTML = '';

            const totalP = pagesCount();
            if(!totalP) return;

            // Convert 1-based currentPage to 0-based index for dot highlighting
            const modPage = ((currentPage - 1) % totalP + totalP) % totalP;

            for(let i = 0; i < totalP; i++){
                const dot = document.createElement('button');
                dot.className = 'carousel-dot';
                if(i === modPage) dot.classList.add('active');
                dot.addEventListener('click', ()=>{
                    if(!transitioning) goToPage(i + 1); // i+1 => restore to 1-based
                });
                dotsEl.appendChild(dot);
            }
        }

        /**
         * Safely navigate to pageIndex (1-based).
         */
        function goToPage(pageIndex, direction = ''){
            if(transitioning) return;
            const totalP = pagesCount();

            // If not infinite, do not allow going out of range
            if(!infinite){
                if(pageIndex < 1) pageIndex = 1;
                if(pageIndex > totalP) pageIndex = totalP;
            }

            moveExact(pageIndex);
        }

        /**
         * moveExact => offset = -(targetPage-1) * pageWidth
         */
        function moveExact(targetPage){
            if(transitioning) return;
            transitioning = true;

            pageWidth = measurePageWidth(track, columns, gapPx);
            debugLog('moveExact => pageWidth=', pageWidth, 'currentPage=', currentPage, 'targetPage=', targetPage);

            track.style.transition = 'transform 0.3s ease';

            // 1-based offset => (targetPage - 1)
            const offset = -(targetPage - 1) * pageWidth;
            track.style.transform = `translateX(${offset}px)`;

            if(currentTransitionEndCallback){
                track.removeEventListener('transitionend', currentTransitionEndCallback);
            }
            currentTransitionEndCallback = () => {
                if(!track.isConnected) return;
                track.style.transition = 'none';
                currentPage = targetPage;
                if(!isEditor && infinite){
                    fixInfinite();
                }
                updateDots();
                transitioning = false;
            };
            track.addEventListener('transitionend', currentTransitionEndCallback, { once:true });
        }

        /**
         * fixInfinite => if currentPage is out of the "middle" chunk, we snap to it.
         * Because we duplicated items in the track if infinite, we keep the user in the middle set.
         */
        function fixInfinite(){
            if(isEditor) return; // In editor, skip triple logic
            if(!infinite) return;
            const totalP = pagesCount();
            if(totalP === 0) return;

            // For triple-dup logic, the middle chunk is from totalP+1 to 2*totalP
            const minPage = totalP + 1;
            const maxPage = 2 * totalP;

            debugLog('fixInfinite => currentPage=', currentPage, 'pagesCount=', totalP);

            if(currentPage > maxPage){
                currentPage -= totalP;
                track.style.transform = `translateX(-${((currentPage - 1) * pageWidth)}px)`;
            } else if(currentPage < minPage){
                currentPage += totalP;
                track.style.transform = `translateX(-${((currentPage - 1) * pageWidth)}px)`;
            }
        }

        /**
         * Move forward by n pages (1-based).
         */
        function moveForward(n = 1){
            const nextPage = currentPage + n;
            // If not infinite, do not exceed totalP
            if((!infinite || isEditor) && nextPage > pagesCount()) return;
            goToPage(nextPage, 'next');
        }

        /**
         * Move backward by n pages (1-based).
         */
        function moveBackward(n = 1){
            const prevPage = currentPage - n;
            // If not infinite, do not go below page 1
            if((!infinite || isEditor) && prevPage < 1) return;
            goToPage(prevPage, 'back');
        }

        /**
         * handleSwipeEnd => if user swipes enough, go forward/back
         */
        function handleSwipeEnd(diff){
            pageWidth = measurePageWidth(track, columns, gapPx);
            const threshold = pageWidth * 0.2;
            debugLog('handleSwipeEnd => diff=', diff, 'threshold=', threshold);

            if(Math.abs(diff) > threshold){
                if(diff < 0) moveForward(1);
                else moveBackward(1);
            } else {
                track.style.transition = 'transform 0.3s ease';
                track.style.transform = `translateX(-${(currentPage - 1) * pageWidth}px)`;
            }
        }

        // ARROWS
        const prevBtn = container.parentElement.querySelector('.passivewp-carousel-button-prev');
        const nextBtn = container.parentElement.querySelector('.passivewp-carousel-button-next');
        if(prevBtn) prevBtn.addEventListener('click', () => (!transitioning) && moveBackward(1));
        if(nextBtn) nextBtn.addEventListener('click', () => (!transitioning) && moveForward(1));

        // Drag/swipe only on front-end
        if(!isEditor){
            track.addEventListener('mousedown',(e)=>{
                if(transitioning) return;
                isDown = true;
                track.style.transition = 'none';
                startX = e.pageX;
                e.preventDefault();
            });
            track.addEventListener('mousemove',(e)=>{
                if(!isDown || transitioning) return;
                const diff = e.pageX - startX;
                track.style.transform = `translateX(${ diff - (currentPage - 1)* pageWidth }px)`;
                e.preventDefault();
            });
            track.addEventListener('mouseup',(e)=>{
                if(!isDown) return;
                isDown = false;
                const diff = e.pageX - startX;
                handleSwipeEnd(diff);
            });
            track.addEventListener('mouseleave',(e)=>{
                if(isDown){
                    isDown = false;
                    const diff = e.pageX - startX;
                    handleSwipeEnd(diff);
                }
            });
            track.addEventListener('touchstart',(e)=>{
                if(transitioning) return;
                isDown = true;
                track.style.transition = 'none';
                startX = e.touches[0].pageX;
            }, { passive:false });
            track.addEventListener('touchmove',(e)=>{
                if(!isDown || transitioning) return;
                const diff = e.touches[0].pageX - startX;
                track.style.transform = `translateX(${ diff - (currentPage - 1)* pageWidth }px)`;
                e.preventDefault();
            }, { passive:false });
            track.addEventListener('touchend',(e)=>{
                if(!isDown) return;
                isDown = false;
                const diff = e.changedTouches[0].pageX - startX;
                handleSwipeEnd(diff);
            }, { passive:false });
        }

        /**
         * Wait for all images => then init (so that widths are measured correctly).
         */
        function waitForImagesThenInit(){
            const imgs = Array.from(track.querySelectorAll('img'));
            if(!imgs.length){
                doInit();
                return;
            }
            let loaded = 0;
            imgs.forEach(img => {
                if(img.complete){
                    loaded++;
                    if(loaded === imgs.length) doInit();
                } else {
                    img.addEventListener('load', ()=>{
                        loaded++;
                        if(loaded === imgs.length) doInit();
                    });
                    img.addEventListener('error', ()=>{
                        loaded++;
                        if(loaded === imgs.length) doInit();
                    });
                }
            });
        }

        function doInit(){
            debugLog('Initializing carousel...');

            // Determine how many columns we want now:
            columns = getResponsiveColumns(baseCols);

            // 1) set item widths
            setItemWidths(container, track, columns, gapPx);

            // 2) measure page
            pageWidth = measurePageWidth(track, columns, gapPx);
            debugLog('pageWidth=', pageWidth, 'pagesCount=', pagesCount());

            // 3) update dots
            updateDots();

            // 4) If infinite + front-end + multiple pages => jump to middle chunk
            if(!isEditor && infinite && pagesCount() > 1){
                // For triple-dup logic, move to the middle set => currentPage = pagesCount() + 1
                currentPage = pagesCount() + 1;
                track.style.transition = 'none';
                track.style.transform = `translateX(-${(currentPage - 1) * pageWidth}px)`;
            }
            track.offsetWidth; // reflow

            track.style.opacity = '1';
            setTimeout(()=>{
                track.style.transition = 'transform 0.3s ease';
            },50);

            updateDots();
        }

        waitForImagesThenInit();

        // teardown if track removed
        const observer = new MutationObserver(()=>{
            if(!track.isConnected){
                if(currentTransitionEndCallback){
                    track.removeEventListener('transitionend', currentTransitionEndCallback);
                }
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList:true, subtree:true });

        // watch window resize
        let resizeTimer;
        function handleResize(){
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(()=>{
                debugLog('Window resized => re-setting widths');

                // 1) Recompute how many columns now (still respecting block’s columns if >=600px):
                columns = getResponsiveColumns(baseCols);

                // 2) Re-run sizing logic
                setItemWidths(container, track, columns, gapPx);
                pageWidth = measurePageWidth(track, columns, gapPx);

                // 3) Reset transform & transition
                track.style.transition = 'none';
                track.style.transform = `translateX(-${(currentPage - 1) * pageWidth}px)`;
                track.offsetWidth; // reflow
                setTimeout(()=> {
                    track.style.transition = 'transform 0.3s ease';
                },50);

                // 4) Also update dots so the correct number of pages is shown
                updateDots();
            },150);
        }
        window.addEventListener('resize', handleResize);
    }

    function initializeCarousels(){
        const containers = document.querySelectorAll('.passivewp-carousel-wrap .passivewp-carousel-container');
        if(!containers.length) return false;
        containers.forEach(c => initCarousel(c));
        return true;
    }

    function onReady(){
        if(!initializeCarousels()){
            // If no carousels found yet, keep trying until WP/Gutenberg finishes rendering
            if(typeof wp !== 'undefined' && wp.domReady){
                const observer = new MutationObserver(()=>{
                    if(initializeCarousels()){
                        observer.disconnect();
                    }
                });
                observer.observe(document.body, { childList:true, subtree:true });
            }
        }
    }

    if(typeof wp !== 'undefined' && wp.domReady){
        wp.domReady(onReady);
    } else {
        document.addEventListener('DOMContentLoaded', onReady);
    }

})();